import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, RemovableBadge } from '@wit-support/ui';
import { cn } from './lib/cn.js';
/** Решётка ближе к имени, чем базовый `gap-1` бейджа — на `sm` это читается как один токен. */
const SIZE_CLASSES = {
    sm: 'gap-0.5',
    md: 'gap-1',
};
/**
 * Ручной тег диалога.
 *
 * ОБВЕДЁН, А НЕ ЗАЛИТ, И С РЕШЁТКОЙ. В той же строке инбокса стоят чипы тем
 * классификатора — залитые `Badge variant="neutral"`. Тема ставится моделью,
 * тег — человеком, и оператор должен различать их, не вчитываясь: одинаковые
 * на вид чипы слились бы в один список, где непонятно, чему верить. Отсюда
 * `Badge variant="outline"` кита — своей рамки у чипа нет.
 *
 * Кнопка снятия — `RemovableBadge` кита, а не собственная: у кита одна
 * аффорданса «убрать», и второй экземпляр той же кнопки разошёлся бы с ней
 * при первой же правке размера или цвета.
 *
 * Решётка скрыта от скринридера: вслух она читается как «номер» и только
 * мешает — доступное имя чипа это само имя тега.
 */
export function TagChip({ name, size = 'sm', onRemove, className }) {
    const chipClassName = cn('max-w-full', SIZE_CLASSES[size], className);
    const body = (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", className: "text-[var(--color-text-muted)]", children: "#" }), _jsx("span", { className: "truncate", children: name })] }));
    if (onRemove) {
        return (_jsx(RemovableBadge, { variant: "outline", size: size, className: chipClassName, onRemove: onRemove, removeAriaLabel: `Убрать тег ${name}`, children: body }));
    }
    return (_jsx(Badge, { variant: "outline", size: size, className: chipClassName, children: body }));
}
TagChip.displayName = 'TagChip';
/**
 * Ряд тегов с переполнением: лишние прячутся за «+N», но не пропадают — их
 * имена уходят в подпись, так что наведение отвечает «а какие ещё?» без
 * перехода в диалог.
 */
export function TagChipList({ tags, max, size = 'sm', onRemove, className }) {
    if (tags.length === 0)
        return null;
    const shown = max === undefined ? tags : tags.slice(0, max);
    const hidden = max === undefined ? [] : tags.slice(max);
    const hiddenNames = hidden.map((t) => t.name).join(', ');
    return (_jsxs("span", { className: cn('inline-flex min-w-0 flex-wrap items-center gap-1', className), children: [shown.map((tag) => (_jsx(TagChip, { name: tag.name, size: size, ...(onRemove ? { onRemove: () => onRemove(tag) } : {}) }, tag.id))), hidden.length > 0 ? (_jsxs(Badge, { variant: "outline", size: size, role: "img", title: hiddenNames, "aria-label": `Ещё теги: ${hiddenNames}`, className: "shrink-0 border-[var(--color-border-subtle)] text-[var(--color-text-muted)]", children: ["+", hidden.length] })) : null] }));
}
TagChipList.displayName = 'TagChipList';
//# sourceMappingURL=tag-chip.js.map